if (!customElements.get('header-menu-99')) {
  customElements.define(
    'header-menu-99',
    class HeaderMenu99 extends HTMLElement {
      connectedCallback() {
        this.toggleButton = document.querySelector('.header-99__hamburger');
        this.drawer = this.querySelector('.header-99__mobile-menu');
        this.isOpen = false;

        if (!this.toggleButton || !this.drawer) return;

        this.toggleButton.addEventListener('click', () => this.toggle());

        this.drawer.querySelectorAll('a').forEach((link) => {
          link.addEventListener('click', () => this.close());
        });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.isOpen) this.close();
        });

        document.addEventListener('click', (event) => {
          if (this.isOpen && !this.drawer.contains(event.target) && !this.toggleButton.contains(event.target)) {
            this.close();
          }
        });

        this.drawer.addEventListener('transitionend', () => {
          if (!this.isOpen) this.drawer.hidden = true;
        });

        window.matchMedia('(min-width: 769px)').addEventListener('change', (event) => {
          if (event.matches && this.isOpen) this.close();
        });
      }

      toggle() {
        this.isOpen ? this.close() : this.open();
      }

      open() {
        this.drawer.hidden = false;
        this.toggleButton.setAttribute('aria-expanded', 'true');
        this.toggleButton.classList.add('is-active');
        this.isOpen = true;
        requestAnimationFrame(() => this.drawer.classList.add('is-open'));
    }

    close() {
        this.drawer.classList.remove('is-open');
        this.toggleButton.setAttribute('aria-expanded', 'false');
        this.toggleButton.classList.remove('is-active');
        this.isOpen = false;
        }
    }
  );
}